import { forwardRef } from 'react';
import List from './list.js';
import Range from './range.js';
import RangeEditable from './rangeEditable.js';
import OneChoice from './onechoice.js';
import ByPattern from './bypattern.js';
import FilterDate from './date.js';
import wrapperStartTour from './tour.js';
import SliderType from './slider.js';
import HofTier from './hoftier.js';
import LegendPlus from './legendplus.js';

function Separator() {
  return (
    <div className="flex justify-center h-full"><div className="h-full w-[1px] bg-purple-6" /></div>
  );
}

const Item = wrapperStartTour(forwardRef((props, ref) => {
  function renderItem() {
    const { item } = props;

    if (item?.typecomponent === 'list') return <List ref={ref} {...props} />;
    if (item?.typecomponent === 'range') return <Range ref={ref} {...props} />;
    if (item?.typecomponent === 'rangeEditable') return <RangeEditable ref={ref} {...props} />;
    if (item?.typecomponent === 'onechoice') return <OneChoice ref={ref} {...props} />;
    if (item?.typecomponent === 'bypattern') return <ByPattern ref={ref} {...props} />;
    if (item?.typecomponent === 'date') return <FilterDate ref={ref} {...props} />;
    if (item?.typecomponent === 'separator') return <Separator />;
    if (item?.typecomponent === 'slider') return <SliderType ref={ref} {...props} />;
    if (item?.typecomponent === 'hoftier') return <HofTier ref={ref} {...props} />;
    if (item?.typecomponent === 'legendplus') return <LegendPlus ref={ref} {...props} />;
    return <div className="">{item.title}</div>;
  }
  return renderItem();
}));
// eslint-disable-next-line import/prefer-default-export
export { Item };
